import { PAUSEQUEUE_TASK, PAUSEQUEUE_TASK_SUCCESSFUL, PAUSEQUEUE_TASK_FAILED } from './actionTypes';

const initialState = {
    pauseQueueError: null, messageTask: null, loadingUpdateTask: false
}

const pauseQueueTask = (state = initialState, action) => {
    switch (action.type) {
        case PAUSEQUEUE_TASK:
            state = {
                ...state,
                loadingUpdateTask: true,
                pauseQueueError: null
            }
            break;
        case PAUSEQUEUE_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingUpdateTask: false,
                messageTask: action.payload,
                pauseQueueError: null
            }
            break;
        case PAUSEQUEUE_TASK_FAILED:
            state = {
                ...state,
                messageTask: null,
                loadingUpdateTask: false,
                pauseQueueError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default pauseQueueTask;